import {DetailGrid} from "@/components/GridWidget";

import {getParameter} from "@/components/WdiBus/Buttons/data";
import {initFieldDisplayFormater} from "@/components/WdiBus/TableColumnRanderFormats";
import {WdiModalAppProps, wdiCore} from "@/components/WdiControls";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {GridApi} from "@/services/gridapi";
import {formatter, request, ResponseStatus} from "@/utils/request";
import {ProFormInstance} from "@ant-design/pro-form";
import {message, Modal} from "antd";
import {Key, useEffect, useRef, useState} from "react";
import {FormSa, FormSaDetail} from "@/services/sales/sa";
import {Enum} from "@/enums/system";

const {error} = Modal;

const CancelPdModalApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [reloadKey, setReloadKey] = useState(0);
  const [gridSettings, setGridSettings] = useState<any>({});

  useEffect(() => {
    if (props.id) {
      Promise.all([
        GridApi.searchConfig({id: 'FormSACancelPDDetail', allowModifyColumns: true}),
        FormSaDetail.getsEx(Number(props.id)),
        FormSa.get(Number(props.id)),
      ]).then((dataArray) => {
        const responseResult = dataArray[0];
        const resp1 = dataArray[1];
        const resp2 = dataArray[2];
        setDataSource(resp1.data.filter(m => m.syncStatus == Enum.SyncStatus.SYNC_SUCCESS || m.syncStatus1 == Enum.SyncStatus.SYNC_SUCCESS));

        const settings: any = Object.assign({}, responseResult.data, {});

        settings.formSchema.allFields.rowNumber.width = 70;
        settings.formSchema.allFields.ecName.width = 150;
        settings.formSchema.allFields.revenueTypeName.width = 130;
        settings.formSchema.allFields.priceSellinBefore.width = 120;
        settings.formSchema.allFields.priceSellinAfter.width = 120;
        settings.formSchema.allFields.quantityBuy.width = 100;
        settings.formSchema.allFields.quantityFree.width = 100;

        initFieldDisplayFormater(settings.formSchema.allFields);

        settings.formSchema.allFields.supplyStartDate.getDisplayFormater = (text: any, record: any, index: any) => {
          if (record.supplyStartDate) {
            return wdiCore.Date.Join(record.supplyStartDate, record.supplyEndDate);
          }
          return wdiCore.Date.Join(resp2.data.supplyStartDate, resp2.data.supplyEndDate);
        }

        setGridSettings(settings);
        setIsLoaded(true);
      });
    }
  }, [props.id, reloadKey]);

  const onSelectChange = (newSelectedRowKeys: Key[], rows: any[]) => {
    setSelectedRows(rows)
  };

  const pageGridSettings = Object.assign({
    antdProps: {
      dataSource: dataSource,
      rowSelection: {selectedRows, onChange: onSelectChange},
      pagination: {
        pageSize: 100,
        showSizeChanger: true
      },
      rowKey: "formSaDetailId"
    }
  }, gridSettings);

  return (
    <WdiModalForm
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      width={1350}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
      }}
      onFinish={async () => {
        const {data} = props;
        if (!selectedRows || selectedRows?.length == 0) {
          message.error("请选择要取消的行");
          return;
        }
        const args = getParameter(data);
        args.items.push({
          name: "formSaDetailIds",
          value: selectedRows.map(obj => obj.formSaDetailId).join()
        });

        if (confirm("确定要对这些行进行取消操作吗？取消后将立即生效")) {
          const response = await request(data.url, formatter({method: 'POST', body: args}));
          if (response.code == ResponseStatus.SUCCESS) {
            message.success('取消成功');
            props.onSave?.();
          } else {
            error({
              content: response.message,
              okText: '确定',
              onOk: () => {
                setReloadKey(reloadKey + 1);
              }
            });
          }
        }
      }}
    >
      {isLoaded && (
        <DetailGrid {...pageGridSettings} />
      )}
    </WdiModalForm>
  );
};

export default CancelPdModalApp;
